import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import DefaultCompanyInfoPanel from './DefaultCompanyInfoPanel';
// Ensure these CSS files provide the necessary styles for the two-column layout

import '../routes/AuthPage.css'; // For .auth-form-column potentially
import './LoginPageSidePanel.css'; // For .login-side-panel

const AuthPageLayout = ({ children }) => {
    return (
        <div className="auth-page-container-fluid"> {/* Ensure this class is styled for 100vh if not using inline style */}
            <Container fluid className="min-vh-100">
                <Row className="min-vh-100">
                    {/* Left Side: Form Area */}
                    <Col md={6} lg={5} className="d-flex align-items-center justify-content-center bg-light auth-form-column">
                        {children} {/* This will be the AuthFormLayout component */}
                    </Col>

                    {/* Right Side: Company Info Panel */}
                    <Col md={6} lg={7} className="d-none d-md-flex align-items-center justify-content-center login-side-panel">
                        <DefaultCompanyInfoPanel />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AuthPageLayout;